<template>
  <div class="c-user-selector">
    <div class="c-user-selector-search">
      <!-- <el-input
        placeholder="搜索成员"
        prefix-icon="el-icon-search"
        v-model="searchKey"
        size="small"
        @keyup.enter.native="search"
      /> -->
      <el-input
        placeholder="搜索成员"
        prefix-icon="el-icon-search"
        v-model="searchKey"
        size="small"
        @input="search"
      />
    </div>
    <div class="c-user-selector-main">
      <div
        v-if="items.length===users.length && users.length !== 0"
        class="c-user-selector-all"
        @click="selectAll"
      >
        <span class="c-user-selector-all-icon ibass ibass-team" />
        <span class="c-user-selector-all-label">所有项目成员</span>
        <span class="c-user-selector-item-status">
          <em
            class="active ibass"
            :class="{
              'ibass-done': selectedUsers.length === users.length
            }"
          />
        </span>
      </div>
      <div
        v-for="(item, index) in items"
        :key="index"
        class="c-user-selector-item"
        @click="selectUser(item)"
      >
        <img
          :src="item.userPic"
          class="c-user-selector-item-img"
        >
        <span class="c-user-selector-item-name">{{ item.userName }}</span>
        <span class="c-user-selector-item-status">
          <em
            class="active ibass"
            :class="{
              'ibass-done': selectedUsers.indexOf(item)>-1
            }"
          />
        </span>
      </div>
    </div>
    <div
      v-show="selectedUsers.length > 0"
      class="c-user-selector-footer"
      @click="clean"
    >
      <span class="ibass ibass-user" />
      <span class="c-user-selector-clean-label">{{ label }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'UserSelector',
  props: {
    users: {
      type: Array
    },
    defaultUsers: {
      type: Array
    }
  },
  data () {
    return {
      searchKey: '',
      items: this.users,
      label: '只选择自己',
      selectedUsers: []
    }
  },
  watch: {
    users (newValue, oldValue) {
      this.items = newValue
    },
    defaultUsers () {
      this.selectedUsers = this.defaultUsers
    }
  },
  methods: {
    // search: _.debounce(ev => {
    //   console.log('[][][][][][][][][')
    //   this.filterUser()
    // }, 200),
    search () {
      this.filterUser()
    },
    selectUser (item) {
      let index = this.selectedUsers.indexOf(item)
      index > -1 ? this.selectedUsers.splice(index, 1) : this.selectedUsers.push(item)
      this.$emit('selectUser', this.selectedUsers)
    },
    filterUser () {
      let value = this.searchKey ? this.searchKey.toLowerCase() : ''
      // this.items = _.filter(this.users, (o) => { return o.userName.toUpperCase().indexOf(value.toUpperCase()) > -1 })
      this.items = this.users.filter((o) => {
        return (o.userName && o.userName.toLowerCase().indexOf(value) > -1) ||
                (o.pinyin && o.pinyin.toLowerCase().indexOf(value) > -1)
      })
    },
    selectAll () {
      if (this.selectedUsers.length === this.users.length) {
        this.selectedUsers = []
      } else {
        this.selectedUsers = this.users.slice(0)
      }
      this.$emit('selectUser', this.selectedUsers)
    },
    clean () {
      this.selectedUsers = this.users.slice(0, 1)
      this.$emit('selectUser', this.selectedUsers)
    },
    isSelected (item) {
      return this.selectedUsers.some(user => user.userId === item.userId)
    }
  }
}
</script>
<style lang="stylus">
.c-user-selector
  display flex
  flex-direction column
  justify-content flex-start
  align-items flex-start
  flex-wrap nowrap
  width 180px
  color #4a4a4a
  &-search
    margin 0 8px
  &-main
    width 100%
    margin-top 10px
    height 180px
    overflow auto
  &-all
    display flex
    align-items center
    flex-wrap nowrap
    padding 0 10px
    height 36px
    cursor pointer
    &:hover
      background-color #f8f8f9
    &-icon
      color #ed6c00
      margin-right 8px
      width 24px
      display flex
      justify-content center
      align-items center
    &-label
      flex 1
  &-item
    display flex
    align-items center
    flex-wrap nowrap
    padding 0 10px
    height 36px
    cursor pointer
    &:hover
      background-color #f8f8f9
    &-img
      width 24px
      height 24px
      border-radius 50%
    &-name
      flex 1
      padding-left 8px
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
    &-status
      width 20px
      color #fa8919
  &-footer
    display flex
    flex-wrap nowrap
    width 100%
    padding 0 10px
    align-items center
    border-top 1px solid #f0f0f0
    padding-top 5px
    color #adadad
    box-sizing border-box
    cursor pointer
    .ibass-user
      height 22px
      margin-top 3px
      font-size 1rem
  &-clean-label
    margin-left 10px
</style>
